export function getOutputDocuments(interviewees) {
  const allCompleted = interviewees.every(
    (i) => i.interview === "completed" && i.transcript,
  );
  const totalCount = interviewees.length;

  const policyInterviewees = interviewees.filter(
    (i) => i.type?.toString().toLowerCase() === "policies",
  );
  const totalPolicyCount = policyInterviewees.length;
  const completedPolicyWithTranscripts = policyInterviewees.filter(
    (i) => i.interview === "completed" && i.transcript,
  ).length;
  const anyPolicyCompleted = completedPolicyWithTranscripts >= 1;

  const completedWithTranscripts = interviewees.filter(
    (i) => i.interview === "completed" && i.transcript,
  ).length;
  const anyCompleted = completedWithTranscripts >= 1;

  return [
    {
      title: "AI Workflow Assessment",
      subtitle: allCompleted
        ? `${totalCount} interviewee(s) · All interviews complete`
        : `${totalCount} interviewee(s) · Complete all interviews & upload transcripts first`,
      canGenerate: allCompleted,
    },
    {
      title: "AI Policies & Guidelines",
      subtitle: anyPolicyCompleted
        ? `${completedPolicyWithTranscripts}/${totalPolicyCount} completed · Ready to generate`
        : `${totalPolicyCount} interviewee(s) · At least 1 interview with transcript required`,
      canGenerate: anyPolicyCompleted,
    },
  ];
}

export const assessments = [
  {
    id: "acme-corp",
    company: "Acme Corp",
    contact: "Sarah Johnson",
    contactTitle: "CEO",
    email: "sarah@acme.com",
    phone: "+1 555-0101",
    progress: 25,
    type: "AI Readiness",
    status: "active",
    interviews: { total: 4, completed: 1 },
    attention: "3 transcripts missing",
    interviewees: [
      {
        name: "John Smith",
        role: "CTO",
        type: "Readiness",
        interview: "completed",
        transcript: "john_interview.pdf",
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Lisa Chen",
        role: "VP Engineering",
        type: "Readiness",
        interview: "completed",
        transcript: null,
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Mike Davis",
        role: "Head of Data",
        type: "Readiness",
        interview: "scheduled",
        transcript: null,
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Sarah Johnson",
        role: "CEO",
        type: "Policies",
        interview: "pending",
        transcript: null,
        actions: ["record", "upload", "schedule"],
      },
    ],
  },
  {
    id: "techstart-inc",
    company: "TechStart Inc",
    contact: "James Lee",
    contactTitle: "CEO",
    email: "james@techstart.com",
    phone: "+1 555-0202",
    progress: 60,
    type: "AI Readiness",
    status: "active",
    interviews: { total: 3, completed: 2 },
    attention: "1 interview pending",
    interviewees: [
      {
        name: "James Lee",
        role: "CEO",
        type: "Readiness",
        interview: "completed",
        transcript: "james_interview.pdf",
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Anna Park",
        role: "CTO",
        type: "Readiness",
        interview: "completed",
        transcript: "anna_interview.pdf",
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Tom Brown",
        role: "VP Product",
        type: "Readiness",
        interview: "pending",
        transcript: null,
        actions: ["record", "upload", "schedule"],
      },
    ],
  },
  {
    id: "global-retail-co",
    company: "Global Retail Co",
    contact: "Maria Garcia",
    contactTitle: "COO",
    email: "maria@globalretail.com",
    phone: "+1 555-0303",
    progress: 10,
    type: "Policies",
    status: "active",
    interviews: { total: 2, completed: 0 },
    attention: "No interviews started",
    interviewees: [
      {
        name: "Maria Garcia",
        role: "COO",
        type: "Policies",
        interview: "pending",
        transcript: null,
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Kevin Wu",
        role: "Head of IT",
        type: "Policies",
        interview: "pending",
        transcript: null,
        actions: ["record", "upload", "schedule"],
      },
    ],
  },
  {
    id: "finserv-partners",
    company: "FinServ Partners",
    contact: "David Kim",
    contactTitle: "Managing Partner",
    email: "david@finserv.com",
    phone: "+1 555-0404",
    progress: 45,
    type: "AI Readiness",
    status: "active",
    interviews: { total: 5, completed: 3 },
    attention: "2 transcripts missing",
    interviewees: [
      {
        name: "David Kim",
        role: "Managing Partner",
        type: "Readiness",
        interview: "completed",
        transcript: "david_interview.pdf",
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Rachel Green",
        role: "CTO",
        type: "Readiness",
        interview: "completed",
        transcript: null,
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Chris Martin",
        role: "VP Data",
        type: "Readiness",
        interview: "completed",
        transcript: null,
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Emily Stone",
        role: "Head of Compliance",
        type: "Policies",
        interview: "scheduled",
        transcript: null,
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Alex Rivera",
        role: "CEO",
        type: "Readiness",
        interview: "pending",
        transcript: null,
        actions: ["record", "upload", "schedule"],
      },
    ],
  },
  {
    id: "medihealth-labs",
    company: "MediHealth Labs",
    contact: "Priya Patel",
    contactTitle: "CEO",
    email: "priya@medihealth.com",
    phone: "+1 555-0505",
    progress: 80,
    type: "AI Readiness",
    status: "active",
    interviews: { total: 4, completed: 4 },
    attention: "Ready to generate report",
    interviewees: [
      {
        name: "Priya Patel",
        role: "CEO",
        type: "Readiness",
        interview: "completed",
        transcript: "priya_interview.pdf",
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Sam Wilson",
        role: "CTO",
        type: "Readiness",
        interview: "completed",
        transcript: "sam_interview.pdf",
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Nina Rao",
        role: "VP Research",
        type: "Readiness",
        interview: "completed",
        transcript: "nina_interview.pdf",
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Leo Chang",
        role: "Head of AI",
        type: "Readiness",
        interview: "completed",
        transcript: "leo_interview.pdf",
        actions: ["record", "upload", "schedule"],
      },
    ],
  },
  {
    id: "summit-logistics",
    company: "Summit Logistics Group",
    contact: "Rebecca Torres",
    contactTitle: "CEO",
    email: "rebecca@summitlogistics.com",
    phone: "+1 555-0606",
    progress: 100,
    type: "AI Readiness",
    status: "completed",
    interviews: { total: 3, completed: 3 },
    attention: "Assessment complete",
    interviewees: [
      {
        name: "Rebecca Torres",
        role: "CEO",
        type: "Readiness",
        interview: "completed",
        transcript: "rebecca_interview.pdf",
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Marcus Hall",
        role: "CTO",
        type: "Readiness",
        interview: "completed",
        transcript: "marcus_interview.pdf",
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Diane Foster",
        role: "VP Operations",
        type: "Readiness",
        interview: "completed",
        transcript: "diane_interview.pdf",
        actions: ["record", "upload", "schedule"],
      },
    ],
  },
  {
    id: "brightwave-energy",
    company: "BrightWave Energy",
    contact: "Nathan Cole",
    contactTitle: "CEO",
    email: "nathan@brightwaveenergy.com",
    phone: "+1 555-0707",
    progress: 100,
    type: "Policies",
    status: "completed",
    interviews: { total: 4, completed: 4 },
    attention: "Assessment complete",
    interviewees: [
      {
        name: "Nathan Cole",
        role: "CEO",
        type: "Policies",
        interview: "completed",
        transcript: "nathan_interview.pdf",
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Olivia Grant",
        role: "General Counsel",
        type: "Policies",
        interview: "completed",
        transcript: "olivia_interview.pdf",
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Derek Simmons",
        role: "CTO",
        type: "Policies",
        interview: "completed",
        transcript: "derek_interview.pdf",
        actions: ["record", "upload", "schedule"],
      },
      {
        name: "Karen Mitchell",
        role: "Head of Compliance",
        type: "Policies",
        interview: "completed",
        transcript: "karen_interview.pdf",
        actions: ["record", "upload", "schedule"],
      },
    ],
  },
];
